import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { productPath } from '../seo/site';
import { onScroll } from '../utils/onScroll';
import './WelcomeSection.css';

const WelcomeSection = ({ content, products = [] }) => {
  const contentRef = useRef(null);
  const bgRef = useRef(null);

  useEffect(() => {
    return onScroll(() => {
      const scrolled = window.pageYOffset;
      const contentRate = scrolled * 0.1;
      const bgRate = scrolled * 0.04;

      if (contentRef.current) {
        contentRef.current.style.transform = `translateY(${contentRate}px)`;
      }
      if (bgRef.current) {
        bgRef.current.style.transform = `translateY(${bgRate}px)`;
      }
    });
  }, []);

  return (
    <section id="welcome" className="welcome-section">
      <div className="welcome-bg" ref={bgRef}>
        <div className="welcome-grid" aria-hidden="true" />
        <div className="welcome-glow" aria-hidden="true" />
      </div>

      <div ref={contentRef} className="welcome-content">
        <div className="welcome-hero">
          <span className="welcome-hero-glow" aria-hidden="true" />

          <div className="welcome-title-wrap">
            <h1 className="welcome-title">{content.title}</h1>
          </div>

          {content.description && (
            <p
              className="welcome-description"
              dangerouslySetInnerHTML={{ __html: content.description }}
            />
          )}

          {products.length > 0 && (
            <div className="welcome-apps-group">
              {products.map((product, index) => (
                <Link
                  key={product.id}
                  to={productPath(product.id)}
                  className="welcome-app"
                  style={{ '--accent': product.accentColor, '--delay': `${0.5 + index * 0.1}s` }}
                  aria-label={`Learn more about ${product.title}`}
                >
                  <span className="welcome-app-icon-wrap">
                    <img
                      src={product.app.image}
                      alt={product.app.imageAlt}
                      className="welcome-app-icon"
                      width={88}
                      height={88}
                      decoding="async"
                      fetchPriority={index < 2 ? 'high' : 'low'}
                    />
                  </span>
                  <span className="welcome-app-name">{product.title}</span>
                  {content.highlights?.[index] && (
                    <span className="welcome-app-byline">{content.highlights[index]}</span>
                  )}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="scroll-indicator" aria-hidden="true">
        <div className="scroll-arrow" />
      </div>
    </section>
  );
};

export default WelcomeSection;
